import { render, staticRenderFns } from "./MyTeams.vue?vue&type=template&id=75a5db5e&"
import script from "./MyTeams.vue?vue&type=script&lang=js&"
export * from "./MyTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports